// API Configuration for Production
// This file determines which backend API to use based on environment

export const apiConfig = {
  production: {
    // Direct Fly.io backend URL (Firebase Hosting rewrites no longer used)
    apiUrl: 'https://the-hole.fly.dev/api',
  },
  development: {
    apiUrl: 'http://localhost:5000',
  },
  staging: {
    apiUrl: 'https://the-hole.fly.dev/api',
  },
};

export const getApiUrl = () => {
  const env = process.env.NODE_ENV || 'production';
  return apiConfig[env]?.apiUrl || '/api';
};

// Update fetch calls in your app:
// const response = await fetch(`${getApiUrl()}/applications`, { ... })
